import { AuthService, type CheckEmailBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: CheckEmailBodyDto;
};

export const checkEmail = ({ call, requestBody }: TParams) => call(() => AuthService.checkEmail({ requestBody }));
